<script>
import { mapState, mapActions, mapGetters } from 'vuex';

export default {
  name: 'SkistarResortSubareaSelect',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      resortId: state => state.skistar.resorts.resort,
      subareaError: state => state.skistar.resorts.subarea.itemsError,
      subareasLoading: state => state.skistar.resorts.subarea.itemsLoading,
    }),
    ...mapGetters({
      getResortSubareas: 'skistar/getResortSubareas',
    }),
  },
  methods: {
    ...mapActions({
      loadResortSubareas: 'skistar/loadResortSubareas',
      setResortSubarea: 'skistar/setResortSubarea',
    }),
  },
  mounted() {
    if (this.resortId) {
      this.loadResortSubareas();
    }
  },
  watch: {
    resortId() {
      this.loadResortSubareas();
    },
  },
};
</script>

<template>
  <v-autocomplete
    @change="setResortSubarea"
    :items="getResortSubareas"
    :loading="loading || subareasLoading"
    :disabled="disabled || subareasLoading"
    label="Subarea"
    item-value="id"
    item-text="name"
    clearable
  />
</template>



// WEBPACK FOOTER //
// src/components/ski/skistar/SkistarrResortSubareaSelect.vue